var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import Datetime from "react-datetime";
import PropTypes from "prop-types";
import "moment/locale/ru";
import "moment/locale/en-gb";
import "moment/locale/uz-latn";
import "moment/locale/kk";
import { getMomentLocale } from "../../../shared/momentLocale";
var DateRange = function (props) {
    var _a = useState("en-gb"), locale = _a[0], setLocale = _a[1];
    useEffect(function () {
        setLocale(getMomentLocale(props.languageId));
    }, [props.languageId]);
    return [
        _jsx("div", __assign({ className: 'new-datepicker from' }, { children: _jsx(Datetime, { defaultValue: props.dateFrom, dateFormat: 'DD.MM.YYYY', timeFormat: false, className: 'calendar', locale: locale, inputProps: { readOnly: true }, readonly: true, onChange: props.startDateChange }) }), 'startDate-new'),
        _jsx("span", { className: 'new-datepicker new-datepicker--deliminator' }, 'datepicker--deliminator'),
        _jsx("div", __assign({ className: 'new-datepicker to' }, { children: _jsx(Datetime, { defaultValue: props.dateTo, dateFormat: 'DD.MM.YYYY', timeFormat: false, className: 'calendar', locale: locale, inputProps: { readOnly: true }, onChange: props.endDateChange }) }), 'endDate-new')
    ];
};
DateRange.propTypes = {
    startDateChange: PropTypes.func.isRequired,
    endDateChange: PropTypes.func.isRequired,
    languageId: PropTypes.any
};
export default DateRange;



// WEBPACK FOOTER //
// ./src/components/shared/newDate/DateRange.jsx